import Axios from 'axios'
import { REGISTER_GYM_SUCCESS, REGISTER_GYM_FAILURE } from '../mutation-types'

export default {
  state: {
    drawer: false
  },
  getters: {
    drawerState(state) {
      return state.drawer
    }
  },
  mutations: {
    setSideDrawer(state) {
      state.drawer = !state.drawer
    },
  },
  actions: {
    setGym: async ({ commit }, formData) => {
      commit('setLoading')
      await Axios.post(process.env.VUE_APP_API_URL_GYMS, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(res => {
          console.log(res.data)
          commit(REGISTER_GYM_SUCCESS)
        })
        .catch(error => {
          console.error(error.response)
          commit(REGISTER_GYM_FAILURE)
        })
      commit('setLoading')
    },
    sideDrawerChanged({ commit }) {
      commit('setSideDrawer')
    }
  }
}
